import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/environment/e_title_w.png'
import _imports_1 from '../../assets/img/environment/xueshan.png'
import _imports_2 from '../../assets/img/environment/aq_bg.png'
import _imports_3 from '../../assets/img/environment/pm25_lz.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-30c933e8")

_pushScopeId("data-v-30c933e8")
const _hoisted_1 = { class: "environment" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "env-title" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createVNode("div", {
    class: "app-particles-canvas",
    id: "env-bg",
    style: {"margin-top":"50vw"}
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", {
  class: "app-particles-canvas",
  id: "zhangwei",
  style: {"width":"100vw","margin":"-10vw auto 0 auto","position":"absolute"}
}, null, -1)
const _hoisted_4 = {
  id: "env-dufu",
  style: {"height":"86.72vw","margin-top":"90vw"}
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { style: {"opacity":"0","animation":"fadeInUp 1.5s 0s ease forwards","color":"#231815"} }, "杜甫诚不欺我！在成都真的可以", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { style: {"opacity":"0","animation":"fadeInUp 1.5s 0.5s ease forwards","font-size":"9vw","color":"#13b7f3","font-family":"'almmdfdk'"} }, "窗含西岭千秋雪", -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<br data-v-30c933e8><br data-v-30c933e8><p style=\"opacity:0;animation:fadeInUp 1.5s 0s ease forwards;\" data-v-30c933e8>成都观山爱好者</p><p style=\"font-weight:bold;opacity:0;animation:fadeInUp 1.5s 0.3s ease forwards;\" data-v-30c933e8>张巍</p><p style=\"opacity:0;animation:fadeInUp 1.5s 0.6s ease forwards;\" data-v-30c933e8>连续7年发布在大成都范围内</p><p style=\"font-size:8vw;font-weight:bold;opacity:0;animation:fadeInUp 1.5s 0.9s ease forwards;\" data-v-30c933e8>推窗见雪山</p><p style=\"opacity:0;animation:fadeInUp 1.5s 1.2s ease forwards;\" data-v-30c933e8>数据统计情况</p>", 7)
const _hoisted_16 = {
  style: {"height":"90.46vw"},
  id: "jianxue"
}
const _hoisted_17 = {
  key: 0,
  class: "jianxue",
  style: {"opacity":"0","animation":"fadeIn 1.5s 0s ease forwards"}
}
const _hoisted_18 = { class: "year" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("天")
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  style: {"width":"100vw"},
  alt: ""
}, null, -1)
const _hoisted_21 = {
  style: {"height":"143.84vw"},
  id: "aq-content"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { style: {"opacity":"0","animation":"fadeInUp 1.5s 0s ease forwards","font-size":"9vw","padding":"0","text-align":"center","font-family":"'almmdfdk'","color":"#13b7f3"} }, "被雪山环抱的幸福", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("p", { style: {"opacity":"0","animation":"fadeInUp 1.5s 0.5s ease forwards","padding":"0","text-align":"center","font-size":"4.0vw"} }, "来源于成都多年来持续对大气污染的治理", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "aq" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    style: {"opacity":"0","animation":"fadeIn 1.5s 0s ease forwards"},
    alt: ""
  }),
  /*#__PURE__*/_createVNode("div", { class: "aq-content" }, [
    /*#__PURE__*/_createVNode("span", {
      style: {"font-size":"13vw","color":"#898989"},
      id: "aq-year"
    }, "2013"),
    /*#__PURE__*/_createVNode("div", { style: {"font-size":"2.2vw","line-height":"2.2em","border-radius":"3vw","background":"#898989","color":"white","width":"28vw","text-align":"center"} }, "成都的空气质量优良天数"),
    /*#__PURE__*/_createVNode("span", {
      style: {"font-size":"19vw","color":"#1ae6d0","margin-top":"2vw"},
      id: "aq-count"
    }, "132")
  ])
], -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("div", {
  id: "pm-chart-box",
  style: {"height":"113.72vw"}
}, [
  /*#__PURE__*/_createVNode("p", null, "成都市近年来空气质量优良天数"),
  /*#__PURE__*/_createVNode("div", {
    id: "pm-chart",
    style: {"width":"69.44vw","height":"101.48vw","margin":"3vw 0 0 12vw"}
  })
], -1)
const _hoisted_26 = {
  class: "aq-pm",
  id: "pm-particle"
}
const _hoisted_27 = {
  style: {"margin-top":"50vw","height":"53.02vw"},
  id: "pm-text"
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<p style=\"opacity:0;animation:fadeInUp 1.5s 0s ease forwards;\" data-v-30c933e8>党的十八大以来</p><p style=\"opacity:0;animation:fadeInUp 1.5s 0.3s ease forwards;\" data-v-30c933e8>我国以前所未有的力度向大气污染宣战</p><p style=\"opacity:0;animation:fadeInUp 1.5s 0.6s ease forwards;\" data-v-30c933e8>从2013年到2022年</p><p style=\"opacity:0;animation:fadeInUp 1.5s 0.9s ease forwards;\" data-v-30c933e8>我国在GDP翻了一番的情况下</p><p style=\"opacity:0;animation:fadeInUp 1.5s 1.2s ease forwards;\" data-v-30c933e8>PM2.5平均浓度实现十连降</p><p style=\"opacity:0;animation:fadeInUp 1.5s 1.5s ease forwards;color:#c95245;font-size:6.5vw;line-height:1.3em;font-weight:bold;\" data-v-30c933e8>成为全球空气质量</p><p style=\"opacity:0;animation:fadeInUp 1.5s 1.8s ease forwards;color:#c95245;font-size:6.5vw;line-height:1.3em;font-weight:bold;\" data-v-30c933e8>改善速度最快的国家</p>", 7)
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "pm25" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_3,
    alt: ""
  }),
  /*#__PURE__*/_createVNode("div", { class: "pm25-content" }, [
    /*#__PURE__*/_createVNode("span", null, "全国PM2.5平均浓度"),
    /*#__PURE__*/_createVNode("span", {
      style: {"font-size":"16vw","font-family":"'jdzh'"},
      id: "pm-year"
    }, "2013"),
    /*#__PURE__*/_createVNode("div", { style: {"display":"flex","justify-content":"center","align-items":"center"} }, [
      /*#__PURE__*/_createVNode("span", {
        style: {"font-size":"22vw","font-family":"'jdzh'","color":"#1ae6d0","margin-right":"3vw","line-height":"0.8em"},
        id: "pm-count"
      }, "72"),
      /*#__PURE__*/_createVNode("span", { style: {"font-size":"2.5vw","writing-mode":"vertical-rl"} }, "(微克/立方米)")
    ])
  ])
], -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "e-foot" }, " 要像保护眼睛一样保护自然和生态环境，推动形成人与自然和谐共生新格局。 ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TextParticle = _resolveComponent("TextParticle")

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      (_ctx.isShowDufu >= 1)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7
          ]))
        : _createCommentVNode("", true),
      (_ctx.isShowDufu >= 2)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _hoisted_9
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_16, [
      (_ctx.isShowJxs)
        ? (_openBlock(), _createBlock("div", _hoisted_17, [
            _createVNode("span", _hoisted_18, _toDisplayString(_ctx.xsYear), 1),
            _createVNode("div", null, [
              _createVNode("span", null, _toDisplayString(_ctx.xsCount), 1),
              _hoisted_19
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_20
    ]),
    _createVNode("div", _hoisted_21, [
      _withDirectives(_createVNode("div", null, [
        _hoisted_22,
        _hoisted_23,
        _hoisted_24
      ], 512), [
        [_vShow, _ctx.isShowAq]
      ])
    ]),
    _hoisted_25,
    _createVNode("div", _hoisted_26, [
      (_ctx.isShowPm25)
        ? (_openBlock(), _createBlock(_component_TextParticle, {
            key: 0,
            text: "PM2.5"
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_27, [
      (_ctx.isShowPmText)
        ? (_openBlock(), _createBlock("div", _hoisted_28, [
            _hoisted_29
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_36,
    _hoisted_37
  ], 512)), [
    [_vShow, _ctx.isShow]
  ])
})